import { render } from "./Restaurants.vue?vue&type=template&id=33f590dd&scoped=true"
import script from "./Restaurants.vue?vue&type=script&lang=js"
export * from "./Restaurants.vue?vue&type=script&lang=js"

import "./Restaurants.vue?vue&type=style&index=0&id=33f590dd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33f590dd"

export default script